import React, { useEffect, useState } from "react";

// all css comes in FilterBox.css in PreReadFile  justify-content-between
// py-2 mt-2

const FilterBox = ({
  setChecked,
  checked,
  setFilter,
  filter,
  setClick1,
  setAllPost,
  setSelectedData,
  selectedData
}) => {
  const { sortChecked, timeChecked } = checked;
  const [time,setTime]=useState({
    index:"",
    value:""
  })
  const handleSortCheckboxChange = (e, index) => {
    setAllPost([]);
    setChecked({ ...checked, sortChecked: index === sortChecked ? 1 : index });
    setFilter({ ...filter, page: 1, sortBy: e.target.value });
    setAllPost([]);
  };

  const handleTimeCheckboxChange = () => {
    setAllPost([]);
    setChecked({ ...checked, timeChecked: time.index === timeChecked ? 1 : time.index });
    if (time.value === "null") {
      setFilter({ ...filter, page: 1, time: null });
    } else {
      setFilter({ ...filter, page: 1, time: time.value });
    }
    setClick1(false);
    
  };
  const handleClear=()=>{
      setClick1(false)
      setFilter({ ...filter, page: 1, time: null });
      setChecked({
        sortChecked: 2,
        timeChecked: 1,
      });
      setSelectedData({})
  }
  useEffect(()=>{
    setTime(selectedData)
  },[])
  return (
    <>
      <div className="p-2 filter_container">
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="filter_heading">Filter</h4>
          <img
            src="/images/UpArrow.svg"
            alt=""
            style={{ cursor: "pointer" }}
            onClick={(e) => setClick1(false)}
          />
        </div>
        {/* gap-2 px-3   col-5    d-flex align-item-center flex-column subject_subbox */}
        <div className="mx-2">
        </div>
        <div className="mx-2">
          {/* <h5 className="mb-2 filter_first_heading">TIME</h5> */}
          <div>
            {/* <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input"
                type="checkbox"
                value="null"
                id="flexCheckDefault"
                checked={1 === timeChecked}
                onChange={(e) => handleTimeCheckboxChange(e, 1)}
              />
              <span>All day</span>
            </div> */}
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input chk"
                type="checkbox"
                value="today"
                id=""
                checked={2 === time?.index}
                onChange={(e) => {setTime({index:2,value:e.target.value});setSelectedData({index:2,value:e.target.value})}}
              />
              <span className="spn mt-0">Today</span>
            </div>
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input chk"
                type="checkbox"
                value="yesterday"
                id="flexCheckDefault"
                checked={3 === time?.index}
                onChange={(e) => {setTime({index:3,value:e.target.value});setSelectedData({index:3,value:e.target.value})}}
              />
              <span className="spn">Yesterday</span>
            </div>
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input chk"
                type="checkbox"
                value="thisweek"
                id="flexCheckDefault"
                checked={4 === time?.index}
                onChange={(e) => {setTime({index:4,value:e.target.value});setSelectedData({index:4,value:e.target.value})}}
              />
              <span className="spn">This Week</span>
            </div>
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input chk"
                type="checkbox"
                value="thismonth"
                id="flexCheckDefault"
                checked={5 === time?.index}
                onChange={(e) => {setTime({index:5,value:e.target.value});setSelectedData({index:5,value:e.target.value})}}
              />
              <span className="spn">This Month</span>
            </div>
            <div className="d-flex justify-content-between">
              <button className="clrBtn" onClick={()=>{handleClear()}}>Clear</button>
              <button className="aplyBtn" onClick={()=>{handleTimeCheckboxChange()}}>Apply</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBox;
